<template>
  <el-tabs v-model="editableTabsValue2" @tab-click="handleChange" >
    <el-tab-pane
      v-for="item in Categories"
      :key="item.goodsCategoryNameEn"
      :label="item.goodsCategoryName"
      :name="item.goodsCategoryNameEn"
    >
      <!-- <child  v-bind:arg = {name} ></child> -->
      <div class="child1">
        <div class="kqb-media-list hotclass">
          <div
            class="kqb-media-item"
            v-for="(item, index) in subjectList"
            :key="index"
            @click="pageJump('/mediaRecommendationDetail', item)"
          >
            <img v-lazy="item.goodsImgs" class="kqb-media-object" />
            <div class="kqb-media-inner">
              <div class="kqb-media-title ellipsis">
                {{ item.goodsLongName }}
              </div>
              <div class="kqb-media-desc ellipsis"></div>
              <!-- <div class="kqb-media-label">主讲人：{{item.goodsLecturerName}}</div> -->
              <div class="kqb-media-label">{{ item.goodsQuantity }}人学习</div>
              <div
                class="kqb-media-footer fc-FF1A1A"
                v-if="item.goodsIsVip == 1"
              >
                {{ item.goodsQuantity }}集/VIP
              </div>
              <div class="kqb-media-footer fc-F82E3D" v-else>
                <div class="fc-FF1A1A">{{ item.goodsQuantity }}集</div>
                <div class="fc-FF1A1A fc-000">{{item.goodsNewPrice/100}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  created:function(){
      this.getAllCategories();
      // this.getSubjectByCategoriesName();
  },
  data() {
    return {
      editableTabsValue2: "",
      temp: "",
      subjectList: [],
      Categories:[],      //所有分类
      tabIndex: 2,
    };
  },
  methods: {
    onLoad: function () {
      const thisObj = this;
      thisObj.selectSubjectByNameEn();
    },
    //获取一级分类
    getAllCategories(){
      const that = this;
      console.log("getAllCategories ")
      that.$api
        .get(
          that.requestUrl+
          "/knowledge/goods/getAllCategories?fromDevice=h5&storeId=" +
            this.storeId,
          {}
        )
        .then((res) => {
          if(res.success){
            that.Categories = res.resultData;
            console.log("Categories")
            console.log(that.Categories);
            that.editableTabsValue2 = that.Categories[0].goodsCategoryNameEn;
            that.temp = that.Categories[0].goodsCategoryNameEn;
            that.getSubjectByCategoriesName();
          }else{
            console.log("未成功获取数据")
          }
        })
    },
    //获取指定分类下的课程
    getSubjectByCategoriesName() {
      const that = this;
      var name = this.temp;
      that.$api
        .get(
          that.requestUrl +
            "/knowledge/goods/selectSubjectByGoodsCategoryNameEn/" +
            name +
            "?fromDevice=h5",
          {}
        )
        .then((res) => {
          if (res.success) {
            that.subjectList = res.resultData;
          } else {
            console.error("未能成功获取数据");
          }
        });
    },
    // 页面跳转
    pageJump(uri, item) {
      const thisObj = this;
      let queryData = {
        fileType: item.goodsType,
        goodsId: item.goodsId,
        goodsName: item.goodsLongName,
        goodsLecturerName: item.goodsLecturerName,
        goodsBriefDesc: item.goodsBriefDesc,
        goodsLecturerDesc: item.goodsLecturerDesc,
        goodsQuantity: item.goodsQuantity,
        countStudy: item.countStudy,
        goodsNo: item.goodsNo,
        goodsDetailImgs: item.goodsNativeDetailDesc,
        goodsFirstImg: item.goodsFirstImg,
        goodsIsVip: item.goodsIsVip,
        isUser: "0",
        storeId: this.storeId,
        userId: this.userId,
      };
      thisObj.$router.push({
        path: uri,
        query: queryData,
      });
    },
    handleChange(targetName) {
      console.log(targetName.name)
      this.temp = targetName.name;
      //重新刷新数据
      this.getSubjectByCategoriesName();
    },
  },
};
</script>

<style lang="css" scoped>
/* .child1{
  width: 90%;
  height: auto;
  margin: -30px 0px 0px -28px;
} */
.fc-78482F {
  color: #78482f;
}
.page {
  overflow-x: hidden;
  background: aliceblue;
}

.header {
  width: 100%;
  height: 60px;
  margin: 0;
}

.header > img {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}

.kqb-tools {
  margin: 0 30px 0 30px;
  padding: 20px 0 20px 0;
}

.kqb-tools .kqb-location {
  -webkit-align-items: center;
  align-items: center;
  width: 200px;
  height: 56px;
  margin: 0 24px 0 0;
  font-size: 28px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: rgba(255, 255, 255, 1);
}

.kqb-tools .kqb-location .icon-arrow-right-thin {
  width: 30px;
  height: 30px;
  margin: -2px 0 0 28px;
  font-size: 32px;
  transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  /* IE 9 */
  -moz-transform: rotate(90deg);
  /* Firefox */
  -webkit-transform: rotate(90deg);
  /* Safari 和 Chrome */
  -o-transform: rotate(90deg);
  /* Opera */
}

.kqb-search-bar {
  /* width: 434px; */
  width: 100%;
  height: 56px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 5px 1px rgba(4, 19, 57, 0.21);
  /* border-radius: 10px; */
  border-radius: 30px;
  left: -4px;
}

.kqb-search-bar .icon_search {
  position: absolute;
  left: 16px;
  top: 50%;
  width: 27px;
  height: 28px;
  transform: translate(0, -50%);
}

.kqb-search-bar input {
  height: 56px;
  line-height: 56px;
  padding: 0 36px 0 55px;
  font-size: 28px;
  border: 0;
}

.kqb-search-bar .placeholder {
  font-size: 28px;
  font-family: Adobe Heiti Std R;
  font-weight: normal;
  color: rgba(199, 199, 199, 1);
}

.time {
  color: rgb(19, 10, 10);
  font-size: 26px;
  width: 40px;
}

.time1 {
  color: rgb(19, 10, 10);
  font-size: 26px;
  width: 40px;
  margin-left: 92%;
  margin-top: -6%;
}

.nav-bar {
  display: flex;
  background-color: aliceblue;
  margin: -28px 0px 19px 3px;
  /* padding: 26px 0 30px 0; */
  background: rgba(255, 255, 255, 1);
  /* box-shadow: 6px 6px 30px 0px rgba(58, 60, 62, 0.14); */
  border-radius: 10px;
  box-sizing: border-box;
}

.nav-bar .nav-bar-item {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  text-align: center;
  font-size: 24px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.nav-bar .nav-bar-item img {
  max-width: 80px;
  height: 80px;
  margin: 0 auto;
}

.nav-bar .nav-bar-item div {
  padding: 16px 0 0 0;
}

.bannerswipers {
  width: 100%;
  height: 377px;
  overflow: hidden;
}

.bannerswipers img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  display: block;
}

/*用来包裹所有的小圆点  */
.bannerdots {
  width: auto;
  height: auto;
  display: flex;
  flex-direction: row;
  position: absolute;
  right: 30px;
  bottom: 20px;
}

/*未选中时的小圆点样式 */
.bannerdot {
  width: 16px;
  height: 16px;
  margin-right: 26px;
  background-color: #d1d1ce;
  border-radius: 16px;
}

/*选中以后的小圆点样式  */
.banneractive {
  background-color: #d0021b;
}

.kqb-media-item {
  margin: 46px 0;
  box-shadow: 0px 0px 5px 1px rgba(4, 19, 57, 0.21);
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
}

.kqb-media-object {
  max-width: 200px;
}

.section-title {
  margin: 61px 43px 47px 43px;
  padding: 0 0 0 28px;
  font-size: 33px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #000000;
}

.section-title:before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  width: 8px;
  height: 34px;
  background: rgba(249, 206, 23, 1);
  border-radius: 4px;
  transform: translate(0, -50%);
}

/* 分割线 */
.tableTitle {
  position: relative;
  margin: 0 auto;
  width: auto;
  height: 1px;
  background-color: #d4d4d4;
  text-align: center;
  font-size: 16px;
  color: rgba(101, 101, 101, 1);
}
.midText {
  position: absolute;
  left: 50%;
  background-color: #ffffff;
  padding: 0 15px;
  transform: translateX(-50%) translateY(-50%);
}

.section-title.disp-flex-between .more {
  align-self: flex-end;
  margin: 0 0 1px 0;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-style: normal;
  color: rgba(51, 51, 51, 0.5);
}

.section-title.disp-flex-between .more div.icon {
  width: 22px;
  height: 22px;
  margin: 0 0 0 9px;
  background: rgba(205, 203, 206, 1);
  border-radius: 50%;
}

.section-title.disp-flex-between .more div.icon:before,
.section-title.disp-flex-between .more div.icon:after {
  content: "";
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(0, -50%);
}

.section-title.disp-flex-between .more div.icon:after {
  content: "\e602";
  font-family: "iconfont" !important;
  font-size: 15px;
  left: 50%;
  top: 50%;
  color: #fff;
  transform: translate(-50%, -50%);
}

/*音频组件*/
.kqb-audios {
  padding: 44px 60px 44px 49px;
  box-sizing: border-box;
  box-shadow: 0px 0px 5px 1px rgba(4, 19, 57, 0.21);
  border-radius: 14px;
  background: rgba(255, 255, 255, 1);
}

.kqb-audios .kqb-media-item {
  margin: 0;
  padding: 0;
  box-shadow: none;
}

.kqb-audios .kqb-media-item .kqb-media-title {
  font-size: 30px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.kqb-audios .kqb-media-item .kqb-media-object.circle {
  max-width: 87px;
  height: 87px;
}

.kqb-audios .kqb-media-item .kqb-media-footer {
  margin: 14px 0 0 0;
  font-size: 26px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
}

.kqb-audios .kqb-media-tools {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 27px 0 0 0;
}

.kqb-audios .kqb-media-tools .icon-media-player,
.kqb-audios .kqb-media-tools .icon-media-stop {
  margin: 0 120px;
  font-size: 84px;
}

.kqb-audios .kqb-media-tools .icon-media-previous,
.kqb-audios .kqb-media-tools .icon-media-next {
  font-size: 60px;
}

/*进度条长度  */
.kqb-audios .slid {
  flex: 1;
  position: relative;
}

.kqb-audios slider {
  width: 100%;
  margin: 15px 0 0 16px;
}

/* 音频推荐 */
.audio-recommend.kqb-media-list {
  margin: 76px 43px 0 43px;
}

.audio-recommend.kqb-media-list .kqb-media-item {
  padding: 20px;
  box-shadow: 6px 6px 30px 0px rgba(58, 60, 62, 0.14);
}

.audio-recommend.kqb-media-list .kqb-media-item .kqb-media-group {
  -webkit-flex: 0 0 332px;
  flex: 0 0 332px;
  margin: -41px 0 0 0;
}

.audio-recommend.kqb-media-list .kqb-media-item .kqb-media-group img {
  max-width: 332px;
  min-width: 332px;
  width: 332px;
  height: 190px;
  border-radius: 10px;
}

.audio-recommend.kqb-media-list .kqb-media-item .kqb-media-inner {
  width: 45%;
  margin: 0 0 0 16px;
}

.audio-recommend.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-title {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}

.audio-recommend.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-desc {
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 0.7);
}

.audio-recommend.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-footer
  .fc-FF1A1A {
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(255, 48, 26, 1);
}

.audio-recommend.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-footer
  .fc-FF1A1A
  .fc-30 {
  font-size: 30px;
}

button.kqb-btn.bgC-FFCC00-FFCC00 {
  width: 127px;
  height: 44px;
  line-height: 44px;
  margin: 0;
  padding: 0;
  text-align: center;
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  background: linear-gradient(
    -70deg,
    rgba(255, 204, 0, 1),
    rgba(255, 221, 0, 1)
  );
  border-radius: 0px 22px 22px 28px;
  border: 0;
  box-shadow: none;
}

.doyoulike.kqb-media-list,
.hotclass.kqb-media-list {
  margin: 33px 20px;
}

.doyoulike.kqb-media-list .kqb-media-item,
.hotclass.kqb-media-list .kqb-media-item {
  display: block;
  padding: 0;
  box-shadow: none;
}
.doyoulike.kqb-media-list {
  margin-bottom: 200px;
}
/* 热门课程 */
.hotclass.kqb-media-list {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}

.hotclass.kqb-media-list .kqb-media-item {
  width: 48%;
  margin: 46px 0 0 0;
}

.hotclass.kqb-media-list .kqb-media-item .kqb-media-object {
  max-width: 100%;
  margin: 0;
  border: 1px solid #f9f9f9;
  border-radius: 10px;
  box-sizing: border-box;
}

.hotclass.kqb-media-list .kqb-media-item .kqb-media-inner .kqb-media-label {
  border: 0;
}

.hotclass.kqb-media-list .kqb-media-item .kqb-media-inner .kqb-media-title {
  margin: 18px 0 11px 0;
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.hotclass.kqb-media-list .kqb-media-item .kqb-media-inner .kqb-media-desc,
.hotclass.kqb-media-list .kqb-media-item .kqb-media-inner .kqb-media-label {
  width: 100%;
  line-height: 1.1;
  margin: 0 0 22px 0;
  text-align: left;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(170, 170, 170, 1);
}

.hotclass.kqb-media-list .kqb-media-item .kqb-media-inner .kqb-media-desc {
  margin: 0 0 11px 0;
  color: rgba(102, 102, 102, 1);
}

.hotclass.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-footer
  div {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(170, 170, 170, 1);
}

.hotclass.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-footer.fc-FF1A1A,
.hotclass.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-footer
  div.fc-FF1A1A {
  font-size: 23px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(255, 26, 26, 1);
}

/* 猜你喜欢
.doyoulike.kqb-media-list .kqb-media-item .kqb-media-object-group .mask {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 46px;
  padding: 0 17px;
  line-height: 46px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  background: rgba(0, 0, 0, 0.5);
} */

.doyoulike.kqb-media-list .kqb-media-item .kqb-media-object {
  max-width: 100%;
  height: 367px;
  border-radius: 10px;
}

.doyoulike.kqb-media-list .kqb-media-inner .kqb-media-item .kqb-media-title {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
}

.doyoulike.kqb-media-list .kqb-media-item .kqb-media-inner .kqb-media-footer {
  margin: 24px 0 0 0;
}

.doyoulike.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-footer
  div.fc-000 {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
}

.doyoulike.kqb-media-list
  .kqb-media-item
  .kqb-media-inner
  .kqb-media-footer
  div.fc-FF1A1A {
  font-size: 23px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(255, 26, 26, 1);
}

/*modal*/
.modal {
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}

.BGurl-modal {
  width: 90%;
  height: 755px;
  margin: 36% 0 0 0;
  padding: 80px 0 0 50px;
  box-sizing: border-box;
}

.BGurl-modal .artword {
  max-width: 418px;
  height: 121px;
  margin: 0 auto;
}

.BGurl-modal .fc-875940 {
  max-width: 418px;
  margin: 26px auto 0 auto;
  font-size: 24px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: rgba(135, 89, 64, 1);
}

.modal .nav-bar {
  width: 80%;
  margin: 33px auto 41px auto;
}

.modal .nav-bar .nav-bar-item {
  font-size: 26px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(120, 72, 47, 1);
}

.modal .nav-bar .nav-bar-item img {
  max-width: 70px;
  height: 70px;
}

.modal .kqb-btn {
  position: absolute;
  bottom: 120px;
  left: 50%;
  width: 506px;
  height: 85px;
  margin: 0 auto;
  margin-left: 30px;
  border: 0;
  background: linear-gradient(
    90deg,
    rgba(219, 178, 146, 1) 0%,
    rgba(248, 223, 196, 1) 100%
  );
  box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.5);
  border-radius: 43px;
  transform: translate(-50%, 0);
}

.modal .kqb-btn text {
  font-size: 36px;
  font-family: MicrosoftYaHei-Bold;
  color: rgba(120, 72, 47, 1);
}

.modal .kqb-btn text:first-child {
  font-weight: bold;
}

.modal .icon-canel2 {
  position: absolute;
  bottom: -80px;
  left: 50%;
  color: #fff;
  margin-left: 30px;
  transform: translate(-50%, 0);
}

button.kqb-btn.fc-78482F {
  background-color: #78482f;
}

button.kqb-btn.fc-78482F span:first-child {
  font-size: 40px;
  font-weight: bold;
}

.share-button {
  position: fixed;
  bottom: 140px;
  right: 30px;
  width: 70px;
  height: 70px;
  border-radius: 50%;
}
</style>
